import {useMutation} from "@tanstack/react-query";
import {validateAddress} from "../services/LocationService";

export function useAddressValidate() {
    return useMutation({
        mutationFn: validateAddress,
    });
}
